import { createGlobalStyle } from '@withjoy/joykit';

const RichTextGlobalStyle = createGlobalStyle`
  .jodit-editor h1:first-child, 
  .jodit-editor h2:first-child, 
  .jodit-editor h3:first-child, 
  .jodit-editor h4:first-child, 
  .jodit-editor h5:first-child, 
  .jodit-editor h6:first-child,
  .jodit-editor p:first-child {
    margin-top: 0;
  }
  /*
   * Doubled class: RichTextEditorGlobalStyle resets these with "all: revert" at equal specificity, and global styles
   * re-inject in a different order after a client-side round trip, so long links stopped wrapping on return.
   */
  .jodit-editor.jodit-editor p {
    word-break: break-word;
  }
  .jodit-editor.jodit-editor a {
    word-break: break-word;
  }
`;

export { RichTextGlobalStyle };
